import { ActionBar, ChakraBox, ChakraFlex, FAIconName } from '@equip.health/ui';

export const CarePlanErrorFallback = () => {
  return (
    <ChakraFlex margin="18px" padding="18px" width="100%">
      <ChakraBox>
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          id="care-plan-error-fallback"
          text="We encountered an unexpected error loading the care plan."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
